import { CarrierAndServiceSchema } from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import * as z from "zod/v4";

export const getCarrierServiceCombinations = {
  name: "getCarrierServiceCombinations" as const,
  input: z.object({
    includeDisabled: z.boolean(),
    includeMerchantCarriers: z.boolean(),
  }),
  output: z.object({ options: z.array(CarrierAndServiceSchema) }),
};
